import Icon from 'components/Icon';

import image from './image.svg';

import styles from './styles.module.scss';

const UserInfoIcon = ({ handleClick }) => (
    <Icon
        alt="userIcon"
        className={styles.icon}
        image={image}
        onClick={handleClick}
    />
);

export default UserInfoIcon;
